<template>
  <div>
    <v-dialog persistent v-model="showDialog" width="550" eager>
      <v-card>
        <v-card-title class="justify-space-between">
          {{ title }}
          <v-btn fab text small @click="$emit('closeDialog')"
            ><v-icon class="text-right">close</v-icon></v-btn
          >
        </v-card-title>
        <v-card-text>
          <v-form ref="addPrizeForm">
            <v-row dense>
              <v-col cols="12" md="7">
                <v-text-field
                  outlined
                  dense
                  label="Prize title"
                  v-model="currentPrize.title"
                  :rules="requiredRule"
                />
              </v-col>
              <v-col cols="12" md="5">
                <v-text-field
                  outlined
                  dense
                  label="No. of winners"
                  v-model="currentPrize.noOfWinners"
                  :rules="requiredRule"
                />
              </v-col>
              <v-col cols="12" md="12">
                <v-text-field
                  outlined
                  dense
                  label="What is the prize?"
                  v-model="currentPrize.description"
                  :rules="requiredRule"
                />
              </v-col>
              <v-col cols="12" md="12">
                <v-text-field
                  outlined
                  dense
                  label="Sponsored by"
                  v-model="currentPrize.sponsor"
                  :rules="requiredRule"
                />
              </v-col>
              <v-col cols="12">
                <div class="text-subtitle font-weight-bold">
                  Showcase your prize and sponsor when conducting your prize
                  draw
                </div>
              </v-col>
              <v-col cols="12">
                <v-tabs v-model="tab">
                  <v-tab>Upload prize image</v-tab>
                  <v-tab>Upload sponsor’s logo</v-tab>
                </v-tabs>
                <v-tabs-items v-model="tab">
                  <v-tab-item>
                    <v-row dense>
                      <v-col cols="12">
                        <vue-dropzone
                          ref="prizeImageDropzone"
                          id="prizeImageDropzone"
                          :options="dropzoneOptions"
                          :useCustomSlot="true"
                          @vdropzone-file-added="prizeImageAdded"
                          @vdropzone-thumbnail="attachPrizeImageThumbnail"
                        >
                          <p class="mt-n-10 text-body-1 primary--text">
                            Drag and drop or
                            <span class="text-decoration-underline"
                              >Browse files</span
                            >
                          </p>
                        </vue-dropzone>
                      </v-col>
                      <v-col cols="12" class="text-center">
                        <v-hover
                          v-slot:default="{ hover }"
                          class="mt-5 mx-auto"
                        >
                          <v-card
                            elevation="2"
                            class="rounded"
                            width="120"
                            height="120"
                          >
                            <v-img
                              :src="
                                prizeImageThumbnail != ''
                                  ? prizeImageThumbnail
                                  : currentPrize.image
                              "
                              width="120"
                              height="120"
                            >
                              <v-scale-transition origin="center">
                                <v-card
                                  v-if="hover"
                                  elevation="0"
                                  class="primary"
                                  height="100%"
                                  style="opacity: 0.6"
                                >
                                  <p class="text-right pa-0">
                                    <v-btn
                                      fab
                                      text
                                      small
                                      @click="removePrizeImage"
                                      ><v-icon class="text-right white--text"
                                        >close</v-icon
                                      ></v-btn
                                    >
                                  </p>
                                  <v-row
                                    class="fill-height ma-0 mt-n14"
                                    align="center"
                                    justify="center"
                                  >
                                    <v-icon color="white" size="40"
                                      >image</v-icon
                                    >
                                  </v-row>
                                </v-card>
                              </v-scale-transition>
                            </v-img>
                          </v-card>
                        </v-hover>
                      </v-col>
                    </v-row>
                  </v-tab-item>
                  <v-tab-item>
                    <v-row dense>
                      <v-col cols="12">
                        <vue-dropzone
                          ref="sponsorsLogoDropzone"
                          id="sponsorsLogoDropzone"
                          :options="dropzoneOptions"
                          :useCustomSlot="true"
                          @vdropzone-file-added="sponsorsLogoAdded"
                          @vdropzone-thumbnail="attachSponsorsLogoThumbnail"
                        >
                          <p class="mt-n-10 text-body-1 primary--text">
                            Drag and drop or
                            <span class="text-decoration-underline"
                              >Browse files</span
                            >
                          </p>
                        </vue-dropzone>
                      </v-col>
                      <v-col
                        cols="12"
                        md=""
                        class="text-center d-flex justify-center"
                      >
                        <v-hover
                          v-slot:default="{ hover }"
                          class="mt-5 mx-auto"
                        >
                          <v-card
                            elevation="2"
                            class="rounded"
                            width="120"
                            height="120"
                          >
                            <v-img
                              :src="
                                sponsorsLogoThumbnail != ''
                                  ? sponsorsLogoThumbnail
                                  : currentPrize.sponsorsLogo
                              "
                              width="120"
                              height="120"
                            >
                              <v-scale-transition origin="center">
                                <v-card
                                  v-if="hover"
                                  elevation="0"
                                  class="primary"
                                  height="100%"
                                  style="opacity: 0.6"
                                >
                                  <p class="text-right pa-0">
                                    <v-btn
                                      fab
                                      text
                                      small
                                      @click="removeSponsorsLogo"
                                      ><v-icon class="text-right white--text"
                                        >close</v-icon
                                      ></v-btn
                                    >
                                  </p>
                                  <v-row
                                    class="fill-height ma-0 mt-n14"
                                    align="center"
                                    justify="center"
                                  >
                                    <v-icon color="white" size="40"
                                      >image</v-icon
                                    >
                                  </v-row>
                                </v-card>
                              </v-scale-transition>
                            </v-img>
                          </v-card>
                        </v-hover>
                      </v-col>
                    </v-row>
                  </v-tab-item>
                </v-tabs-items>
              </v-col>
            </v-row>

            <v-btn
              color="primary"
              depressed
              block
              class="text-body-1 mt-10"
              @click="addPrize"
              >Save prize</v-btn
            >
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="loadingDialog" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Uploading images
          <v-progress-linear
            color="white"
            class="mb-0"
            :value="progress"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import {getDownloadUrlForRef, getStorageRef, uploadFileInStorage, uploadStringInStorage} from "@/shared/firebase_utils";
let uuid = require("uuid");

export default {
  props: {
    showDialog: { type: Boolean },
    title: { type: String },
  },

  components: {
    vueDropzone: vue2Dropzone,
  },
  computed: {
    ...mapGetters(["currentEvent", "currentPrize"]),
    progress: function() {
      let progress =
        this.prizeImageUploadProgress + this.sponsorsLogoUploadProgress;
      if (this.prizeImageThumbnail != "" && this.sponsorsLogoThumbnail != "") {
        progress = (progress / 200) * 100;
      }
      return progress;
    },
  },
  watch: {
    progress: function(value) {
      if (value == 100) {
        //this.loadingDialog = false;
        this.$emit("closeDialog");
      }
    },
  },
  data() {
    return {
      tab: 0,
      showUploadedPrize: false,
      showSponsorsLogo: false,
      dropzoneOptions: {
        url: "https://httpbin.org/post",
        thumbnailWidth: 150,
        thumbnailHeight: 150,
        addRemoveLinks: false,
        acceptedFiles: ".jpg, .jpeg, .png",
      },
      prizeImageUploadProgress: 0,
      sponsorsLogoUploadProgress: 0,
      uploadProgress: 100,
      prizeImageThumbnail: "",
      sponsorsLogoThumbnail: "",
      prizeImageURL: "",
      sponsorsLogoURL: "",
      prizeImageFile: null,
      sponsorsLogoFile: null,
      uploadedImages: [],
      loadingDialog: false,
      requiredRule: [(v) => v.length > 0 || "This is a required field"],
    };
  },
  methods: {
    attachPrizeImageThumbnail(file, dataURL) {
      this.$refs.prizeImageDropzone.removeAllFiles();
      this.prizeImageThumbnail = dataURL;
    },
    attachSponsorsLogoThumbnail(file, dataURL) {
      this.$refs.sponsorsLogoDropzone.removeAllFiles();
      this.sponsorsLogoThumbnail = dataURL;
    },
    prizeImageAdded(file) {
      this.$refs.prizeImageDropzone.removeAllFiles();
      this.prizeImagefile = file;
    },
    sponsorsLogoAdded(file) {
      this.$refs.sponsorsLogoDropzone.removeAllFiles();
      this.sponsorsLogoFile = file;
    },
    async uploadPrizeImage(file) {
      try {
        //create a unique file name
        const imageName = uuid.v1();
        const metaData = {
          contentType: "image/png",
        };
        //Get a firebase storage reference
        const imageRef = getStorageRef(`images/${imageName}.png`);

        var uploadTask = await uploadFileInStorage(imageRef, file, metaData);
        uploadTask.on(
          "state_changed",
          (snapshot) => {
            switch (snapshot.state) {
              case 'paused': // or 'paused'
                console.log("Upload is paused");
                break;
              case 'running': // or 'running'
                this.prizeImageUploadProgress =
                  (snapshot.bytesTransferred / snapshot.totalBytes) * 100;

                if (this.prizeImageUploadProgress == 100)
                  this.currentPrize.image = "";
                break;
            }
          },
          (error) => {
            // Handle unsuccessful uploads
          },
          () => {
            // Handle successful uploads on complete
            getDownloadUrlForRef(uploadTask.snapshot.ref).then((downloadURL) => {
              this.currentPrize.image = downloadURL;
            });
          }
        );
      } catch (error) {
        console.log("Error occurred while uploading the prize image ", error);
      }
    },
    async uploadSponsorsLogo(file) {
      try {
        //create a unique file name
        const imageName = uuid.v1();
        const metaData = {
          contentType: "image/png",
        };
        //Get a firebase storage reference
        const imageRef = getStorageRef(`images/${imageName}.png`);

        var uploadTask = await uploadFileInStorage(imageRef, file, metaData);
        uploadTask.on(
          "state_changed",
          (snapshot) => {
            switch (snapshot.state) {
              case 'paused': // or 'paused'
                console.log("Upload is paused");
                break;
              case 'running': // or 'running'
                this.sponsorsLogoUploadProgress =
                  (snapshot.bytesTransferred / snapshot.totalBytes) * 100;

                break;
            }
          },
          (error) => {
            // Handle unsuccessful uploads
          },
          () => {
            // Handle successful uploads on complete
            getDownloadUrlForRef(uploadTask.snapshot.ref).then((downloadURL) => {
              this.currentPrize.sponsorsLogo = downloadURL;
            });
          }
        );
      } catch (error) {
        console.log("Error occurred while uploading the sponsors logo ", error);
      }
    },
    async addPrize() {
      let index = this.currentEvent.prizes.indexOf(this.currentPrize);
      if (index == -1) {
        this.currentEvent.prizes.push(this.currentPrize);
      }
      //TODO: Single image, no image and all image condition checks before calling promise
      if (this.$refs.addPrizeForm.validate()) {
        if (this.prizeImagefile != null && this.sponsorsLogoFile != null) {
          this.loadingDialog = true;
          await Promise.all([
            this.uploadPrizeImage(this.prizeImagefile),
            this.uploadSponsorsLogo(this.sponsorsLogoFile),
          ]);
        } else {
          if (this.prizeImagefile != null) {
            this.loadingDialog = true;
            await this.uploadPrizeImage(this.prizeImagefile);
          } else if (this.sponsorsLogoFile != null) {
            this.loadingDialog = true;
            await this.uploadSponsorsLogo(this.sponsorsLogoFile);
          } else {
            this.$emit("closeDialog");
          }
        }
      } else {
        console.log("form is invlaid");
      }
    },
    removePrizeImage() {
      if (this.prizeImageThumbnail != "") {
        this.prizeImageThumbnail = "";
      } else {
        this.currentPrize.image = "";
      }
    },
    removeSponsorsLogo() {
      if (this.sponsorsLogoThumbnail != "") {
        this.sponsorsLogoThumbnail = "";
      } else {
        this.currentPrize.sponsorsLogo = "";
      }
    },
  },
};
</script>

<style></style>
